

export let applyProjection = function(coords, isBox=false){
    
    if(coords[0] < -180){
        coords[0] = -180;
    }else if(coords[0] > 180){
        coords[0] = 180;
    }

    let y = 0;
    if((coords[1] > 60)){
        y = Math.log(Math.tan(Math.PI/4 + (60*Math.PI/180)/2));
        let y2 = Math.log(Math.tan(Math.PI/4 + (coords[1]*Math.PI/180)/2));
        y += 1/(1+0.002*Math.pow(coords[1]-60, 2)) * (y2 - y);
    }else if((coords[1] < -60)){
        y = Math.log(Math.tan(Math.PI/4 + (-60*Math.PI/180)/2));
        let y2 = Math.log(Math.tan(Math.PI/4 + (Math.max(coords[1],-75)*Math.PI/180)/2));
        y += 1/(1+0.002*Math.pow(Math.max(-15, coords[1]+60), 2)) * (y2 - y);
    }else{
        
        y = Math.log(Math.tan(Math.PI/4 + (coords[1]*Math.PI/180)/2));
    
    }
    
    let s = 0.6 + 0.4*Math.cos(Math.PI*Math.pow(y,2)/9);
    let x = s*coords[0]*Math.PI/180;
    
    return [x, -y];
}

export let addToBoundingBox = function(resultBox, inputBox){
    addCoordToBoundingBox(resultBox, [inputBox[0].x, inputBox[0].y]);
    addCoordToBoundingBox(resultBox, [inputBox[1].x, inputBox[1].y]);
    return resultBox;
}

export let addCoordToBoundingBox = function(box, coords){
    if(coords[0] == 0 && coords[1] == 0){
        return box;
    }
    // check x
    if(! box[0].x || coords[0] < box[0].x){
        box[0].x = coords[0];
    }
    if(! box[1].x || coords[0] > box[1].x){
        box[1].x = coords[0];
    }
    
    // check y
    if(! box[0].y || coords[1] < box[0].y){
        box[0].y = coords[1];
    }
    if(! box[1].y || coords[1] > box[1].y){
        box[1].y = coords[1];
    }
    
    return box;
};

export let createPath = function(coords){

    let data = '';    
        
    for(let i = 0; i < coords.length; i++){
        let v = coords[i];
        
        if(v[0].length == 2 && v[0][0] === +v[0][0]){
            let last = v[v.length-1][0];
            data += 'M';
            for(let c = 0, l = v.length; c<l; c++){
                let vo = v[c].slice(0);
                if(last && (Math.max(vo[0], last) - Math.min(vo[0], last)) > 180){
                    if(last < 0){
                        vo[0] = (vo[0]<180)? -180: vo[0]-360;
                    }else{
                        vo[0] = (vo[0]>-180)? 180: vo[0]+360;
                    }
                }
                last = vo[0];
                let vn = applyProjection(vo);

                data += vn[0] + ' ' + vn[1];
                if(c != l-1 && vn.length > 2){
                    data += ' ' + vn[2];
                }else if(c != l-1){
                    data += ' L';
                }else{
                    data += ' Z';
                }
            }
        }else{
            let d = createPath(v);
            data += ' ' + d;
        }
    }
       
    return data;
    
};